import { useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { forwardRef, useEffect } from 'react';

import { useDetection } from '@utility/checkout-utils';

import { ChkDrawer } from '../ChkDrawer/ChkDrawer';
import { ChkModal } from '../ChkModal/ChkModal';

import type { CancelModalWrapperProps } from './ChkCancelModalWrapper.types';

export const CancelModalWrapper = forwardRef<
  HTMLDivElement,
  CancelModalWrapperProps
>(({ children, open, handleClose, ...rest }, ref) => {
  const { isMobile } = useDetection();
  const theme = useTheme();

  useEffect(() => {
    if (isMobile) {
      if (open) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [open, isMobile]);

  if (!theme.zoom.isZoomed && isMobile) {
    return (
      <ChkDrawer
        ref={ref}
        open={open}
        slotProps={{ backdrop: { onClick: handleClose } }}
      >
        <StyledBox>{children}</StyledBox>
      </ChkDrawer>
    );
  }

  return (
    <StyledModal
      ref={ref}
      open={open}
      onClose={handleClose}
      fullScreen={theme.zoom.isZoomed}
      {...rest}
    >
      {children}
    </StyledModal>
  );
});

const StyledBox = styled('div')(({ theme }) => ({
  padding: theme.spacing(3, 6, 8),
}));

const StyledModal = styled(ChkModal)(({ theme }) => ({
  '.MuiPaper-root': {
    padding: theme.spacing(3, 6, 8),
    maxWidth: `calc(${theme.breakpoints.values['xs']}px - (2 * ${theme.spacing(
      10
    )}))`,
  },
}));
